if (!customElements.get("collection-cards")) {
  class CollectionCards extends HTMLElement {
    connectedCallback() {
      this.mediaQuery = window.matchMedia("(min-width: 990px)");
      this.handleChange = this.update.bind(this);
      this.mediaQuery.addEventListener("change", this.handleChange);
      this.update();
    }

    disconnectedCallback() {
      this.mediaQuery.removeEventListener("change", this.handleChange);
      this.destroy();
    }

    update() {
      if (!this.mediaQuery.matches) {
        this.destroy();
        return;
      }

      if (this.swiper) {
        return;
      }

      this.swiper = new Swiper(this.querySelector(".swiper"), {
        slidesPerView: "auto",
        spaceBetween: 18,
        watchOverflow: true,
        navigation: {
          prevEl: this.querySelector(".collection-cards__arrow--prev"),
          nextEl: this.querySelector(".collection-cards__arrow--next"),
        },
        pagination: {
          el: this.querySelector(".collection-cards__pagination"),
          clickable: true,
        },
      });
    }

    destroy() {
      if (!this.swiper) {
        return;
      }

      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  customElements.define("collection-cards", CollectionCards);
}
